export class AreaDeleteModel {
    AreaIdToDelete: number;
    AreaIdToTransferUnits: number;
    OwnerOfSharedItemsIds: { [prop: number]: number };
    OwnerOfNotSharedItemsIds: { [prop: number]: number };
    AreaIdToTransferContent: number;
}
